<template lang="pug">

  section.sponsor-header
    h3 Presentado por
      img.logo(src="assets/images/logo-citroen.png")

</template>

<script>
  export default  {
    name: 'sponsor-header',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .sponsor-header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.3rem 0;
    background-color: white;
    box-shadow: 1px 1px 1px rgba(black, 0.1);
  }
  h3{
    font-size: 1rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0678bc;
  }
  .logo{
    width: 70px;
    margin-left: 0.5rem;
  }
</style>
